exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reprove-modal .modal-title[data-v-f4843a28] {\n  font-size: 28px;\n  color: var(--v-gray-darken2);\n  text-align: center;\n}\n.reprove-modal .modal-text[data-v-f4843a28] {\n  font-size: 18px;\n  color: var(--v-gray-darken2);\n}\n.reprove-modal .reprove-form[data-v-f4843a28] {\n  margin-top: 24px;\n  width: 100%;\n}\n.reprove-modal .counter[data-v-f4843a28] {\n  font-size: 12px;\n  color: var(--v-gray-darken2);\n}\n", ""]);

// exports
